/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResponsePrewalkAgentResultsApiV1PublicPrewalkAgentResultsPost
 */
export interface ResponsePrewalkAgentResultsApiV1PublicPrewalkAgentResultsPost {
}

/**
 * Check if a given object implements the ResponsePrewalkAgentResultsApiV1PublicPrewalkAgentResultsPost interface.
 */
export function instanceOfResponsePrewalkAgentResultsApiV1PublicPrewalkAgentResultsPost(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ResponsePrewalkAgentResultsApiV1PublicPrewalkAgentResultsPostFromJSON(json: any): ResponsePrewalkAgentResultsApiV1PublicPrewalkAgentResultsPost {
    return ResponsePrewalkAgentResultsApiV1PublicPrewalkAgentResultsPostFromJSONTyped(json, false);
}

export function ResponsePrewalkAgentResultsApiV1PublicPrewalkAgentResultsPostFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponsePrewalkAgentResultsApiV1PublicPrewalkAgentResultsPost {
    return json;
}

export function ResponsePrewalkAgentResultsApiV1PublicPrewalkAgentResultsPostToJSON(value?: ResponsePrewalkAgentResultsApiV1PublicPrewalkAgentResultsPost | null): any {
    return value;
}

